import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import artesaLogo from '@/assets/artesa_logo.webp';
import { Analytics } from '@/lib/analytics';
import { useOfertaCompleto } from '@/contexts/OfertaContext';

const PublicHeader = () => {
  const completo = useOfertaCompleto();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 pt-3 md:pt-4">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[60] focus:bg-primary focus:text-primary-foreground focus:px-3 focus:py-2 focus:rounded-full"
      >
        Pular para o conteúdo
      </a>
      <div className="container">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-6 rounded-full border border-card/60 bg-card/70 py-2 pl-5 pr-2 shadow-md backdrop-blur-xl backdrop-saturate-150">
          <Link to="/" aria-label="Artesã - Página inicial" className="flex items-center">
            <img
              src={artesaLogo}
              alt="Artesã"
              width={93}
              height={28}
              decoding="async"
              fetchPriority="high"
              className="h-7 w-auto object-contain"
            />
          </Link>

          {/* Desktop */}
          <nav aria-label="Navegação principal" className="hidden md:flex items-center gap-1">
            <Button asChild variant="ghost" size="sm">
              <Link to="/funcionalidades">Funcionalidades</Link>
            </Button>
            <Button asChild variant="ghost" size="sm">
              <Link to="/planos">{completo ? 'Preço' : 'Planos'}</Link>
            </Button>
            <Button asChild variant="ghost" size="sm">
              <Link to="/login">Entrar</Link>
            </Button>
            <Button asChild size="sm" className="ml-1">
              <Link to="/cadastro?plano=avancado" onClick={() => Analytics.clickStartFree('header')}>{completo ? 'Testar grátis por 15 dias' : 'Experimentar grátis'}</Link>
            </Button>
          </nav>

          {/* Mobile toggle */}
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-ink-150 bg-card/60 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? 'Fechar menu de navegação' : 'Abrir menu de navegação'}
            aria-expanded={mobileOpen}
            aria-controls="public-mobile-menu"
          >
            {mobileOpen ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <nav
            id="public-mobile-menu"
            aria-label="Navegação móvel"
            className="md:hidden mt-2 rounded-xl border border-ink-100 bg-card p-4 shadow-md flex flex-col gap-2"
          >
            <Button asChild variant="ghost" className="w-full justify-start">
              <Link to="/funcionalidades" onClick={() => setMobileOpen(false)}>Funcionalidades</Link>
            </Button>
            <Button asChild variant="ghost" className="w-full justify-start">
              <Link to="/planos" onClick={() => setMobileOpen(false)}>{completo ? 'Preço' : 'Planos'}</Link>
            </Button>
            <Button asChild variant="ghost" className="w-full justify-start">
              <Link to="/login" onClick={() => setMobileOpen(false)}>Entrar</Link>
            </Button>
            <Button asChild className="w-full">
              <Link to="/cadastro?plano=avancado" onClick={() => { Analytics.clickStartFree('header_mobile'); setMobileOpen(false); }}>{completo ? 'Testar grátis por 15 dias' : 'Experimentar grátis'}</Link>
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};


export default PublicHeader;
